import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('language') || 'ar', // استخدام اللغة المحفوظة أو العربية كافتراضية
    fallbackLng: 'ar', // تغيير اللغة الاحتياطية للعربية
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // إعدادات الكشف عن اللغة
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'], // حفظ اللغة في localStorage
      lookupLocalStorage: 'language', // اسم المفتاح في localStorage
    },
  });

export default i18n;
